import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React, { useContext } from "react";
import styled from "styled-components";
import { Paper } from "../../../../../../../common/components/libs";
import { OrderStatus } from "../../../../../../../services/orders/models";
import moment from "moment";
import BookingStoreContext from "../../../store/context";
import { PaymentProviderType } from "../../../../../../../services/general/models";
import { useTranslation} from "react-i18next";


const Wrapper = styled(Paper)`
  padding: ${
          props => {
            return props.theme.spacing(6)
          }}px;

  ${props => props.theme.breakpoints.up("md")} {
    padding: ${props => props.theme.spacing(10)}px;
  }
`;


const NoBookings = () => {
    const {i18n, t} = useTranslation(["general", "bookings"]);
    const bookingsStore = useContext(BookingStoreContext);
    const filter = bookingsStore.filter;


    const clearFilters = () => {
        bookingsStore.setBookingsFilter({
            ...filter,
            createdAfter: moment().startOf("day").toDate(),
            createdBefore: moment().endOf("day").toDate(),
            isPaid: null,
            paymentTypes: [
                PaymentProviderType.cloudpayments,
                PaymentProviderType.companyInvoice,
                PaymentProviderType.offline,
                PaymentProviderType.toBankCard,
            ],
            statuses: [
                OrderStatus.accepted,
                OrderStatus.acceptedByKitchen,
                OrderStatus.canceled,
                OrderStatus.canceledWithRefund,
                OrderStatus.canceledByKitchen,
                OrderStatus.finished,
                OrderStatus.givenOut,
                OrderStatus.givenOutToDelivery,
                OrderStatus.new,
                OrderStatus.ready,
                OrderStatus.readyToPickUp,
                OrderStatus.sentToKitchen,
                OrderStatus.paid,
            ],
        });
        bookingsStore.reloadOrders();
    }

    return <div style={{ maxWidth: 500, marginTop: "40px" }}>
        <Wrapper>
            <Typography component="h4" variant="body2" align="center" gutterBottom>
                {t("bookings:noOrders")}
            </Typography>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                <Button variant="contained"
                        color="primary"
                        onClick={() => clearFilters()}
                >
                    {t("bookings:resetFilters")}
                </Button>
            </div>
        </Wrapper>
    </div>
};


export default NoBookings
